var path = '/app-lite/grids/templates/cell.time.html';
var html = "<input class=\"form-control align-left timecell\" time ng-class=\"'colt' + col.index\" ng-input=\"COL_FIELD\" ng-model=\"COL_FIELD\"/>";
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
export default  path;